import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/react-hooks";
import { BrowserRouter } from "react-router-dom";

import getApolloClient from "shared/util/getApolloClient";
import OnDOMReady from "shared/util/OnDOMReady";
import Context from "shared/util/Context";
import isSpa from "shared/util/isSpa";

const NAV_BAR_ROOT_ELEMENT_ID = "navigation";

let NavBar;

if (process.env.PLATFORM === "desktop") {
	NavBar = require("routers/Desktop/NavBar").default;
} else {
	NavBar = require("routers/MobileWeb/NavBar").default;
}

OnDOMReady(() => {
	if (isSpa()) {
		return;
	}

	const root = document.getElementById(NAV_BAR_ROOT_ELEMENT_ID);

	if (!root) return;

	ReactDOM.render(
		<ApolloProvider client={getApolloClient()}>
			<BrowserRouter>
				<NavBar userid={Context.get("userid")} />
			</BrowserRouter>
		</ApolloProvider>,
		root,
	);
});



// WEBPACK FOOTER //
// ./src/features/navbar/index.js